import jQuery from 'jquery';
let $ = jQuery;

// define EVENTs
import "HSNDIR/Flyout.js";
import accessibilityUtility from 'HSNDIR/AccessibilityUtility.js';
    
HSN.BagFlyout = function(config) {
    var scope = this;

    config = (config || {});
    config.closeTag = (config.closeTag = config.closeTag || 'span');
    config.triggerEvent = (config.triggerEvent = config.triggerEvent || HSN.Flyout.TRIGGER_EVENT.HOVER);

    this._application = config.application;
    this.Trigger = $(config.trigger);
    this.Flyout = $(config.flyout);
    this.FlyoutContent = $(config.flyoutContent);
    this.NoAjax = config.noajax;
    this.CommerceService = HSN.Instance()._getCommerceService();
    this.delayMouseLeave = 750;
    this.waitTimeout;
    this.mouseLeaveFunction = null;
    this.autoLeaveFunction = null;
    this.cmPage = 'Bag';
    this.cmCategory = 'Flyout';
    this.keys = accessibilityUtility.GetKeys();
    this.isModalOpen = false;
    this.arrowBtn = this.Trigger.find('#shopping-bag-arrow button')

    /* Removed event this.Trigger.on('click',  because on click it must redirect to checkout/bag also with keyboard navigation*/
    this.Trigger.on('mouseenter', function () {
        if(Modernizr.touchevents) {
            return true;
        }
        else {
            window.clearTimeout(scope.mouseLeaveFunction);
            window.clearTimeout(scope.autoLeaveFunction);
            scope.Flyout.css('top', '65px');
            scope.Open();
            return false;
        }
    });
    this.Trigger.on('mouseleave', function () {
        scope.closeFlyout();
        return false;
    });
    /* ADA events  */
    this.closeFlyout = function () {
        if (scope.GetState() === HSN.Flyout.STATE.OPEN) {
            scope.mouseLeaveFunction = window.setTimeout(function () {
                if (!scope.isModalOpen) {
                    scope.Close();
                    scope.arrowBtn.find('.topnav-arrow')
                                    .css('display', 'none')
                                    .removeClass('arrow-up');
                }
            }, scope.delayMouseLeave);
        }
    }
    this.arrowBtn.on('click', function () {
        if (scope.GetState() === HSN.Flyout.STATE.OPEN) {
            scope.arrowBtn.find('.topnav-arrow').css('display', 'none');
            scope.closeFlyout();
        }
        else { 
            window.clearTimeout(scope.mouseLeaveFunction);
            window.clearTimeout(scope.autoLeaveFunction);
            scope.Flyout.css('top', 'auto');
            scope.arrowBtn.find('.topnav-arrow')
                            .addClass('arrow-up')
                            .css('display', 'inline-block');
            scope.Open();       
        }
        return false;
        
    }).on('keydown', function (e) {
        if (e.keyCode === scope.keys.enter || e.keyCode === scope.keys.spacebar) {
            let isFlyoutOpen = (scope.GetState() === HSN.Flyout.STATE.OPEN);
            scope.arrowBtn.find('.topnav-arrow').css('display', (isFlyoutOpen ? 'none' : 'inline-block'));
        } else if (e.keyCode === scope.keys.esc) {
            scope.closeFlyout();
        }
    }).on('focusout', function (e) {
        if (!$(e.relatedTarget).parents('.flyout').length > 0) {
            scope.closeFlyout();
        }
    });
    this.Flyout.on('keydown', function (e) {
        if (e.keyCode === scope.keys.esc) {
            scope.arrowBtn.attr('aria-expanded', false);
            scope.closeFlyout();
            scope.arrowBtn.focus();
        }
    });
    this.Flyout.on('focusout', function (e) {
        if (!$(e.relatedTarget).parents('.flyout').length && !$(e.relatedTarget).parents('#shopping-bag-arrow').length) {
            scope.closeFlyout();
        }
    });
    //

    this.Flyout.on('click', function (e) {
        window.clearTimeout(scope.autoLeaveFunction);
        e.stopPropagation();
    });

    this.Flyout.on('click', '.checkout-button', function () {
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'checkout');
        window.location.href = '/checkout/bag';
        return false;
    });

    this.Flyout.on('click', '.full-bag-link', function () {
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'fullbag');
        window.location.href = '/checkout/bag';
        return false;
    });

    this.Flyout.on('keyup', '.full-bag-link', function (event) {
        event.preventDefault();
        if (event.keyCode === scope.keys.enter || event.keyCode === scope.keys.spacebar) {
            scope.DispatchAnalytics('RE:header', 'bagflyout', 'fullbag');
            window.location.href = '/checkout/bag';
        }
    });

    this.Flyout.on('click', '.view-save-for-later', function () {
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'saveditems');
        window.location.href = '/checkout/bag?viewSaved=true';
        return false;
    });

    this.Flyout.on('keyup', '.view-save-for-later', function (event) {
        event.preventDefault();
        if (event.keyCode === scope.keys.enter || event.keyCode === scope.keys.spacebar) {
            scope.DispatchAnalytics('RE:header', 'bagflyout', 'saveditems');
            window.location.href = '/checkout/bag?viewSaved=true';
        }
    });

    this.Flyout.on('click', '.bag-link', function () {
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'yourbag');
        window.location.href = $(this).attr('href');
        return false;
    });

    this.Flyout.on('click', '.remove', function () {
        var parent = $(this).closest('.flyout-bag-item');
        scope.AddMask(parent, 'Removing Item');
        var bagIdentity = parent.data('bag-id');
        var bagItemId = parent.data('bi-id');

        scope.DispatchAnalytics('RE:header', 'bagflyout', 'removeitem');
        scope.CommerceService.RemoveBagItem({ bagIdentity: bagIdentity, bagItemId: bagItemId }, {
            callback: function () {
                var quantity = parent.data('bi-quantity');
                var productId = parent.data('product-id');
                var webId = parent.data('web-id');
                var productPrice = parent.data('product-price');
                var webMId = parent.data('product-webmid');

                HSN.DataLayer.helpers.metricEvent(null, "CP:remove", "flyout", productId, quantity);
                HSN.DataLayer.sendData({ 'cartitem_webpid': productId, 'cartitem_qty': quantity, 'cartitem_webid': webId, 'cartitem_webmid': webMId, 'cartitem_price': productPrice});
                HSN.DataLayer.helpers.hsnEvent(null, "RemoveFromBagFlyout", "Success", null, null);
                if (quantity) {
                    HSN.IncreaseBagIconCount(-quantity);
                }
                scope.GetContent();
                HsnDrdPageCache.setCookie('BagTrack', '-1', HsnDrdPageCache.getLowerDomain(), null, '/');
            },
            errorCallBack: function() {
                alert('Unfortunately there was an error attempting to remove your bag item, please try again.');
            }
        });
        return false;
    });
    this.Flyout.on('click', '.remove-warranty', function () {
        var parent = $(this).closest('.flyout-bag-item');
        scope.AddMask(parent, 'Removing Warranty');
        var bagIdentity = parent.data('bag-id');
        var bagItemId = parent.data('bi-id');
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'removehpp');
        scope.CommerceService.RemoveWarrantyFromBagItem({bagIdentity: bagIdentity, bagItemId: bagItemId}, {
            callback: function () {
                scope.GetContent();
            },
            errorCallBack: function () {
                scope.RemoveMask(parent);
                alert('Unfortunately there was an error attempting to remove your warranty, please try again.');
            }
        });
        return false;
    });
    this.Flyout.on('click', '.add-warranty', function () {
        var parent = $(this).closest('.warranty-offer');
        var flyoutBagItem = parent.prev();
        scope.AddMask(flyoutBagItem, 'Adding Warranty');
        var bagIdentity = parent.data('bag-id');
        var bagItemId = parent.data('bi-id');
        var warrantyItemId = $(this).data('warranty-id');
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'addhpp');
        scope.CommerceService.AddWarrantyToBagItem({bagIdentity: bagIdentity, bagItemId: bagItemId, warrantyItemId: warrantyItemId}, {
            callback: function () {
                scope.GetContent();
            },
            errorCallBack: function () {
                scope.RemoveMask(flyoutBagItem);
                alert('Unfortunately there was an error attempting to add your warranty, please try again.');
            }
        });
        return false;
    });
    this.Flyout.on('click', '.switch-to-auto-ship', function() {
        var parent = $(this).closest('.auto-ship-option-container');
        var flyoutBagItem = parent.prev();
        scope.AddMask(flyoutBagItem, 'Updating to AutoShip');

        var bagIdentity = $(this).data('bag-id');
        var basketId = $(this).data('basketId');
        var singleShipWebId = $(this).data('singleShipWebId');
        var autoShipWebId = $(this).data('autoShipId');

        scope.DispatchAnalytics('RE:header', 'bagflyout', 'autoship');

        var autoshipModal = HSN.Instance().GetGenericConfirmModal();
        autoshipModal.SetInputData({ productIdentity: autoShipWebId });
        autoshipModal.SetOkCallback(function() {
            scope.ChangeToAutoship({bagIdentity: bagIdentity, basketId: basketId, singleShipWebId: singleShipWebId, autoShipWebId: autoShipWebId});
            scope.isModalOpen = false;
        });
        autoshipModal.SetCancelCallback(function () {
            scope.isModalOpen = false;
            scope.RemoveMask(flyoutBagItem);
        });
        autoshipModal.SetCloseClickCallback(function () {
            scope.isModalOpen = false;
            scope.RemoveMask(flyoutBagItem);
        });
        autoshipModal.SetErrorCallback(function () {
            scope.isModalOpen = false;
            scope.RemoveMask(flyoutBagItem);
        });
        scope.isModalOpen = true;
        autoshipModal.Show("/autoship/notice");
        return false;
        //scope.CommerceService.ChangeItemSingleShipToAutoShip({BagIdentity: bagIdentity, BasketId: basketId, SingleShipWebId: singleShipWebId, AutoShipId: autoShipWebId}, {
        //    callback: function() {
        //        scope.GetContent();
        //    },
        //    errorCallBack: function() {
        //        scope.RemoveMask(flyoutBagItem);
        //        alert('Unfortunately there was an error attempting to update your item to AutoShip, please try again.');
        //    }
        //});
    });
    this.Flyout.on('click', '.article-modal', function() {
        var articleSlug = $(this).data('articleSlug');
        var articleId = $(this).data('articleId');
        if(isNaN(articleId)) {
            return false;
        }
        if(!articleSlug) {
            articleId = 'default-article-slug';
        }
        HSN.Instance().GetArticleModal().Show('/article/' + articleSlug + '/' + articleId);
        return false;
    });
}
HSN.BagFlyout.prototype = {
    _state: HSN.Flyout.STATE.CLOSED,
    GetState: function() {
        return this._state;
    },
    Close: function () {
        var scope = this;
        if (scope._state === HSN.Flyout.STATE.CLOSED) {
            return;
        }
        scope._application.Events.Trigger(HSN.Flyout.EVENT.BEFORE_CLOSE, scope);
        HSN.RemoveContainerWait();
        scope.Flyout.stop(true, true).slideUp(750)
            .animate(
                { queue: false, duration: 750, complete: function () {
                    scope.Flyout.css('display', 'none');
                }}
            );
        scope.FlyoutContent.hide();
        scope.FlyoutContent.empty();

        scope.arrowBtn.attr('aria-expanded', false);
        scope._state = HSN.Flyout.STATE.CLOSED;
    },
    Open: function (closeAfter) {
        var scope = this;
        if (scope._state === HSN.Flyout.STATE.OPEN) {
            return;
        }
        //THIS IS SOO GHETTO... Used to undo the lessman/arcade menus so we can show the flyout
        if($('#ShopAllHSN').length > 0) {
            $('#ShopAllHSN').click();
        }
        scope._application.Events.Trigger(HSN.Flyout.EVENT.BEFORE_OPEN, scope);
        scope._state = HSN.Flyout.STATE.OPEN;

        scope.waitTimeout = setTimeout(function() {
            HSN.SetContainerWait('#shopping-bag-flyout .flyout', true);
        }, 250);
            
        scope.Flyout.show();
        scope.GetContent();

        if(closeAfter && closeAfter > 0) {
            scope.autoLeaveFunction = window.setTimeout(function() {
                scope.Close();
            }, closeAfter);
        }

        scope.arrowBtn.attr('aria-expanded', true);
        scope._state = HSN.Flyout.STATE.OPEN;
    },
    GetContent: function () {
        var scope = this;
        scope.CommerceService.GetBagFlyout({
            callback: function (data) {
                clearTimeout(scope.waitTimeout);
                HSN.RemoveContainerWait();
                scope.FlyoutContent.html(data);
                scope._application.Events.Trigger(HSN.Flyout.EVENT.AFTER_LOAD, scope);
                scope.FlyoutContent.stop(true, true)
                    .slideDown(750)
                    .animate(
                        { queue: false, duration: 350 }
                )
            },
            errorCallback: function (status) {
                if(status !== 'abort') {
                    alert('Unfortunately there was an error attempting to load the content, please try again.');
                }
            }
        });
    },
    AddMask: function(toElement, text) {
        toElement.prepend('<div class="mask"><div>' + text + '</div></div>');
    },
    RemoveMask: function(fromElement) {
        fromElement.find('.mask').remove();
    },
    DispatchAnalytics: function (category, action, label) {
        HSN.DataLayer.helpers.metricEvent(null, category, action, label);
    },
    ChangeToAutoship: function (data) {
        var scope = this;
        scope.CommerceService.ChangeItemSingleShipToAutoShip({BagIdentity: data.bagIdentity, BasketId: data.basketId, SingleShipWebId: data.singleShipWebId, AutoShipId: data.autoShipWebId}, {
            callback: function() {
                scope.GetContent();
            },
            errorCallBack: function() {
                scope.RemoveMask(flyoutBagItem);
                alert('Unfortunately there was an error attempting to update your item to AutoShip, please try again.');
            }
        });
    },
};
HSN.BagFlyout.EVENT = {
    BAGITEM_REMOVED: 'bagflyout:bagitem_removed',
    WARRANTY_ADDED: 'bagflyout:warranty_added',
    WARRANTY_REMOVED: 'bagflyout:warranty_removed'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/BagFlyout.js